import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=0cca1461&scoped=true"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"
import style0 from "./Play.vue?vue&type=style&index=0&id=0cca1461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca1461",
  null
  
)

export default component.exports